import baustein from "baustein";
import _ from "underscore";
import rothko from "web/script/modules/rothko";
import template from "templates/modules/articles/editorial_product_cards";
import "templates/modules/product_card";

const EDITORIAL_PRODUCT_CARD_IMAGE_SIZE = [400, 500];

export default baustein.register("editorial-product-cards", {
    template,

    getInitialRenderContext() {
        return {
            editorial_product_cards: {
                product_cards: [],
            },
        };
    },

    onInsert() {
        rothko
            .fetch("modules/product_card", this.getParams(), { cache: false })
            .then((productCards) => {
                if (_.isEmpty(productCards)) {
                    this.destroy();
                    return;
                }

                this.setRenderContext({
                    editorial_product_cards: {
                        product_cards: productCards,
                    },
                });
            })
            .catch((e) => console.error(e));
    },

    getParams() {
        return {
            slugs: this.options.slugs,
            image_size: EDITORIAL_PRODUCT_CARD_IMAGE_SIZE,
            context_type: "editorial-article-product",
        };
    },
});
